import { MutableRefObject, useLayoutEffect, useState } from 'react';

/**
 * https://stackoverflow.com/a/57272554/12993819
 */
export default function useDimensions(targetRef: MutableRefObject<any>) {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    if (targetRef.current) {
      setDimensions({
        width: targetRef.current.offsetWidth,
        height: targetRef.current.offsetHeight,
      });
    }
  }, [targetRef]);

  return dimensions;
}
